<template>
  <div class="mobile-upload-bar">
    <b-button variant="outline-secondary" class="bar-btn" @click="$emit('pick')">
      <i class="far fa-images" aria-hidden="true"></i>
      {{ pickLabel }}
    </b-button>
    <b-button variant="primary" class="bar-btn" @click="$refs.cameraInput.click()">
      <i class="fas fa-camera" aria-hidden="true"></i>
      {{ captureLabel }}
    </b-button>
    <input
      ref="cameraInput"
      type="file"
      class="d-none"
      accept="image/jpeg,image/png"
      capture="environment"
      @change="onCaptured"
    />
  </div>
</template>

<script>
/**
 * Phones only: the two ways to add files, kept at the bottom of the patient
 * window's scrolling area where a thumb reaches them. The
 * camera opens straight away; the picture then goes to the upload sheet for
 * its category and details.
 */
export default {
  name: "MobileUploadBar",
  props: {
    pickLabel: {
      type: String,
      default: "เลือกจากเครื่อง",
    },
    captureLabel: {
      type: String,
      default: "ถ่ายรูป",
    },
  },
  methods: {
    onCaptured(event) {
      const files = Array.from(event.target.files || []);
      event.target.value = "";
      if (files.length) this.$emit("captured", files);
    },
  },
  emits: ["pick", "captured"],
};
</script>

<style scoped>
.mobile-upload-bar {
  display: none;
}
@media (max-width: 575.98px) {
  /* ติดขอบล่างของส่วนที่เลื่อนในหน้าต่างคนไข้ ไม่ทับปุ่มท้ายหน้าต่าง */
  .mobile-upload-bar {
    position: sticky;
    bottom: 0;
    z-index: 5;
    display: flex;
    gap: 0.625rem;
    margin: 1rem -0.875rem 0;
    padding: 0.75rem 0.875rem;
    background: #fff;
    border-top: 1px solid #e3e6eb;
  }
  .bar-btn {
    flex: 1 1 0;
    min-height: 52px;
    border-radius: 999px;
    font-size: 0.9375rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }
}
</style>
